/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![HammerRetryIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABx0lEQVR4nL2VPUucQRDHLxAbNY0viFqmtBCs7K6Iong7L0+xz8yhNhZnkzQiiJ1aCIKttXW+QSCioLl8Bz+BFr4UgoEoKnN63nN65+0azcDCsjv7++/OzuzmcnH2gVk+e+87c29tiPgJWH8i6y2QnjqSL28GHx+f6QDWPYNXG5BeIqZj/wz33nciyUEW/lQESFftdIWCH4yGA+t+I3hG5DrTP0yS6f5gAWTZegneuMlmuADJ7xg4kJwA6FCwAFFxPk7gFRcPJEv/Q2QlViS6TiBSBEmPnHPt7ylyg6gDLaFIso6s2/l8/uNzETm2InNJOuK977IdQ5KOOipyUNFZTteOLN8fRViXTZR5tjsqBE3h/Ciy/tQPEp0Elh/IcgakF8i6Q5ROAGvZnphgOJCcFJJ0uN5P11rdxavhRMWph7m/yLLgXLHH4m7hux9rIBAKN6v+DQbPjJWbniAGbmafjvnYzjMZV/es20t8P8GyEQM3s0s1v5aZVCqV2pD1KgZuVvvhaiFqasBSqlReIDxX+aMVq5fsSBYBtG/S+95Kn+UcWL7WL2CdQ9JfIfDamuehzTx430I5LxqwELDuVlKT5I9llxVf1eEOVcTxmoHl8fIAAAAASUVORK5CYII=)
 */
export const HammerRetryIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M19 16a3 3 0 1 0 1.98 5.25 1 1 0 1 1 1.33 1.5A4.98 4.98 0 0 1 14 19a5 5 0 0 1 8-4 1 1 0 0 1 2 0v3a1 1 0 0 1-1 1h-3a1 1 0 0 1 0-2h1.24A3 3 0 0 0 19 16ZM1.23 21.13a1 1 0 0 1 0-1.41l7.48-7.48c.2-.2.5-.2.7 0l2.13 2.12c.2.2.2.52 0 .71l-7.48 7.48a1 1 0 0 1-1.41 0l-1.42-1.42ZM23.12 11.84a.24.24 0 0 1-.23.17c-.43.02-.87.13-1.24.31a.59.59 0 0 1-.44.04 7 7 0 0 0-6.8 1.35.53.53 0 0 1-.71-.01L7.76 7.76a2 2 0 0 1 0-2.83l3.53-3.54a2 2 0 0 1 2.83 0l2.72 2.72.66-.66a1 1 0 0 1 1.41 0l1.41 1.42a1 1 0 0 1 0 1.41l-.65.66 2.94 2.94a2 2 0 0 1 .5 1.96Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
